import React, { useState, useEffect, useRef, useContext } from 'react'
import { IsLoggedContext } from '../Store'
import '../styles/styles.css'
import { config } from '../server'
import {Link} from 'react-router-dom'
import '../styles/spaces.css';
const address = config.url.API_URL

const Spcaes = () => {
	const [createModal, setCreateModal] = useState(false)
	const [nameOfClass, setNameOfClass] = useState('')
	const [user] = useContext(IsLoggedContext)
	const [spaces, setSpaces] = useState([])
	const [description, setDescription] = useState('')
	const [privacy, setPrivacy] = useState('public')

	useEffect(() => {
	let mounted = true
	fetch(address + '/spaces').then(res => res.json()).then(data => {
		if(mounted) {
		setSpaces(data.spaces)
		}
	})
	return () => mounted = false
	}, [spaces])


	function useOutsideAlerter(ref) {
		useEffect(() => {
			/**
			 * Alert if clicked on outside of element
			 */
			function handleClickOutside(event) {
				//alert(createModal)
				if (ref.current && !ref.current.contains(event.target)) {
				//  alert("You clicked outside of me!");
				if(createModal === true) {
				setCreateModal(false)
				} else {
					setCreateModal(true)
				}
				
				}
			}
	
			// Bind the event listener
			document.addEventListener("mousedown", handleClickOutside);
			return () => {
				// Unbind the event listener on clean up
				document.removeEventListener("mousedown", handleClickOutside);
			};
		}, [ref]);
	}



	const wrapperRef = useRef(null);
	useOutsideAlerter(wrapperRef);


	const handleSubmit = (e) => {
		e.preventDefault()
		const requestOptions = {
			method: 'POST',
			headers: { 
			'content-type': 'application/json' },
			body: JSON.stringify({ owner: user, spaceName: nameOfClass, description: description, privacy: privacy })
		};
		//console.log(user)
	if(nameOfClass.length >= 3) {
	fetch(address + '/createSpace', requestOptions).then(res => res.json()).then((data) => {
		//console.log(data)
		setCreateModal(!createModal)
		})
	} else {
		alert('Please enter a longer name!')
		setCreateModal(!createModal)
		return;
	}

	}

	return (
		<>

			<div className="heroContainer">
                <h1>Clusterfy Spaces</h1>
                <p>Collaborate together.</p>
            </div>
			
			<div className="spacesContainer">
				<div className="spacesButtonContainer">
					<button className="tealBtn verticalCenterBtn" onClick={() => setCreateModal(!createModal)}>New Space</button>
                </div>
				
				{spaces.map((space, index) => (
					<div key={JSON.stringify(space._id)} style={{paddingBottom: '2.5%'}}>
						<div key={index} className="spaceCard">
							<div className="spaceCardText">
								<div className="spaceCardTitle">
									{space.spaceName}
								</div>
								<div className="spaceCardDescription">
									{space.description}
								</div>
							</div>
							<Link key={index+95} className="spaceCardBtn" to={`/space/${space.spaceName}`}>
								<div>View</div>
							</Link>
						</div>
					</div>
				))}
			</div>


		<div className="level-right">
			
		</div>
		{createModal && <div ref={wrapperRef} className="Modal">
	<form onSubmit={(e) => handleSubmit(e)}>
		<label style={{color: 'white'}}>Enter the name of your space</label>
	<input placeholder="Subject" className="input" 
		value={nameOfClass}
		type="text" style={{borderRadius: 5}} onChange={e => setNameOfClass(e.target.value)} />
	<label style={{color: 'white'}}>Enter description</label>
	<input placeholder="Description" className="input" 
		value={description}
		type="text" style={{borderRadius: 5}} onChange={e => setDescription(e.target.value)} />

	<div className="control level-item">
		<label className="radio" style={{color: 'white'}}>
		<input type="radio" checked={privacy === 'public'} onChange={() => setPrivacy('public')}/>
		Public
		</label>
		<label className="radio" style={{color: 'white'}}>
		<input type="radio" checked={privacy === 'private'} onChange={() => setPrivacy('private')}/>
		Private
		</label>
		</div>
		
	<div style={{paddingTop: '2.5%'}}>
		<button className="button is-link">Submit</button>
	</div>
	</form>
	
	</div>}

		</>
	)
}

export default Spcaes